document.addEventListener('DOMContentLoaded', function () {
    function getQueryParameter(name) {
        var urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
	}

	function normalizeText(text) {
		return text.trim().replace(/\s+/g, ' ');
	}

	function expandBlocksContainingText(text) {
		var needle = normalizeText(text.toLowerCase());
        var blocks = document.querySelectorAll('.block-expandable');

        blocks.forEach(function (block) {
            // Grab heading, main text and links separately since block.textContent || block.innerText; did not work
            var headingElm = block.querySelector('.block-head h3');
            var headingText = headingElm ? headingElm.textContent : "";

            var textElm = block.querySelector('.block-text');
            var mainText = textElm ? textElm.textContent : "";

            // TODO: Perhaps handle links more elegantly like build a custom indexing convention for LinkItemCollection
            var linkElements = block.querySelectorAll('.block-content-links a');
            var linkTexts = Array.from(linkElements).map(function (el) {
                return el.textContent || "";
            }).join(" ");

            var hayStack = (
                headingText + " " +
                mainText + " " +
                linkTexts
			).toLowerCase();

			hayStack = normalizeText(hayStack);

            if (hayStack.includes(needle)) {
                var blockHead = block.querySelector('.block-head');

                if (blockHead) {
                    toggleContentVisibility(blockHead);
                }
            }
        });
    }

    var searchQuery = getQueryParameter('searchQuery');

    if (searchQuery) {
		var decodedSearchQuery = decodeURIComponent(searchQuery);

		setTimeout(expandBlocksContainingText(decodedSearchQuery), 100)
    }

    document.querySelectorAll('.block-head').forEach(function (blockHead) {
        blockHead.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault(); // Prevent default scrolling behavior for space key
                toggleContentVisibility(this);
            }
        });
    });
});

function forceExpandContent(element) {
    var content = element.nextElementSibling;
    var isExpanded = content.classList.contains('visible');

    if (!isExpanded) {
        content.style.maxHeight = content.scrollHeight + "px";
        content.classList.add('visible');

        var plusIcon = element.querySelector('.toggle-icon__plus');
        var minusIcon = element.querySelector('.toggle-icon__minus');

        plusIcon.style.display = 'none';
        minusIcon.style.display = 'block';

        element.closest('.block-expandable').classList.add('expanded');
    }
}

function toggleContentVisibility(element) {
    var content = element.nextElementSibling;
    var isExpanded = content.classList.contains('visible');

    element.setAttribute('aria-expanded', !isExpanded);
    content.setAttribute('aria-hidden', isExpanded);

    if (isExpanded) {
        content.style.maxHeight = content.scrollHeight + "px";
        window.getComputedStyle(content).maxHeight;

        setTimeout(function() {
            content.style.maxHeight = "0";

            // Remove focusability of the child elements when collapsed
            updateTabIndex(content, -1);
        }, 10);
    } else {
        content.style.maxHeight = content.scrollHeight + "px";

        // Restore focusability of the child elements when expanded
        updateTabIndex(content, 0);

        // After transition, remove fixed max-height
        content.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'max-height' && content.classList.contains('visible')) {
                content.style.maxHeight = 'none';
                content.removeEventListener('transitionend', handler);
            }
        });
    }

    setTimeout(function () {
        content.classList.toggle('visible', !isExpanded);
    }, 10);

    var plusIcon = element.querySelector('.toggle-icon__plus');
    var minusIcon = element.querySelector('.toggle-icon__minus');

    if (isExpanded) {
        plusIcon.style.display = 'block';
        minusIcon.style.display = 'none';
        element.closest('.block-expandable').classList.remove('expanded');
    } else {
        plusIcon.style.display = 'none';
        minusIcon.style.display = 'block';
        element.closest('.block-expandable').classList.add('expanded');
    }
}

// Helper function to update the tabindex of all focusable elements
function updateTabIndex(content, value) {
    const focusableElements = content.querySelectorAll('a, button, input, [tabindex]');
    
    focusableElements.forEach(function(element) {
        element.setAttribute('tabindex', value);
    });
}